import { useEffect, useState } from 'react';

import fetch from 'unfetch';
import { BASE_URL } from '../../globals';

/**
 *
 * @param {*} interest_in should be 0,1,2
 * @returns
 */
const updateInterestedIn = async (interest_in) => {
	const url = `${BASE_URL}/api/profile/interestedIn`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({
			interested_in: interest_in,
		}),
	});

	if (res.ok) {
		const data = await res.json();
		return { status: 'success', data: data };
	} else {
		const data = await res.json();
		return { status: 'error', data: data };
	}
};
export default updateInterestedIn;
